var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGemsLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9985 0L5.35742 20V60L39.9985 80L74.6396 60V20L39.9985 0Z",
    fill: "#82D2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9985 40V0L5.35742 20L39.9985 40Z",
    fill: "#08B7FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35742 20V60L39.9985 40L5.35742 20Z",
    fill: "#006DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6411 20L40 40L74.6411 60V20Z",
    fill: "#08B7FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9985 40L5.35742 60L39.9985 80V40Z",
    fill: "#0050C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80L74.6411 60L40 40V80Z",
    fill: "#006DFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5498 51.2873V28.7129L39.9996 17.4255L20.4495 28.7129V51.2873L39.9996 62.5746L59.5498 51.2873Z",
    fill: "#82D2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5502 51.2873V28.7129L40 17.4255V62.5746L59.5502 51.2873Z",
    fill: "#55CBFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.954 49.0314L32.8951 41.9292L37.0562 46.0903L29.954 49.0314ZM39.5338 47.7788L41.1697 43.8081L35.0821 37.728L31.1089 39.3764L28 36.265L46.9642 29L49.9704 32.0062L42.7179 50.9904L39.5338 47.7788Z",
    fill: "#C5E3EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemsLarge);
export default __webpack_public_path__ + "static/media/gems-large.8875d38a1001d2f044fbe23d71b17d12.svg";
export { ForwardRef as ReactComponent };